import { render } from "./TaskLongFormModal.vue?vue&type=template&id=ea4e0dc4&scoped=true"
import script from "./TaskLongFormModal.vue?vue&type=script&lang=js"
export * from "./TaskLongFormModal.vue?vue&type=script&lang=js"

import "./TaskLongFormModal.vue?vue&type=style&index=0&id=ea4e0dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4e0dc4"]])

export default __exports__